import MultiTransactions from '@pages/multi-transaction-download/MultiTransactionDownload';
import { useCookies } from 'react-cookie';
import { Navigate, Route, Routes } from 'react-router-dom';
import Layout from '../components/layout';
import Home from '../pages/home/Home';
import Login from '../pages/login/Login';
import { routes } from './config';
import { CUSTOMER_CARE_ROLES } from '@constants/roles';

interface MainRoutesProps {
  isAuthenticated: boolean;
}

interface PrivateRouteProps {
  isAuthenticated: boolean;
  role?: string;
  rolesAllowed?: string[];
  children: React.ReactNode;
}

export const MainRoutes: React.FC<MainRoutesProps> = ({ isAuthenticated }) => {
  const [cookies] = useCookies(['role']);
  const role = cookies.role ?? '';

  return (
    <main className="min-h-screen w-full bg-primary-0">
      <Routes>
        <Route element={<Layout />}>
          <Route
            path="/"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                {CUSTOMER_CARE_ROLES.includes(role) ? (
                  <Navigate to="/eligibility-attempts" replace />
                ) : role === 'OfficeHead' ? (
                  <MultiTransactions />
                ) : (
                  <Home />
                )}
              </PrivateRoute>
            }
          />
          {routes.map(({ path, element, rolesAllowed }) => (
            <Route
              key={path}
              path={path}
              element={
                <PrivateRoute
                  isAuthenticated={isAuthenticated}
                  role={role}
                  rolesAllowed={rolesAllowed}
                >
                  {element}
                </PrivateRoute>
              }
            />
          ))}
          <Route path="/login" element={<Login />} />
        </Route>
        <Route
          path="*"
          element={<Navigate to={isAuthenticated ? '/' : '/login'} />}
        />
      </Routes>
    </main>
  );
};

const PrivateRoute: React.FC<PrivateRouteProps> = ({
  isAuthenticated,
  role,
  rolesAllowed,
  children,
}) => {
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }
  if (rolesAllowed && role && !rolesAllowed.includes(role)) {
    return <Navigate to="/" />;
  }
  return <>{children}</>;
};
